"use client";

import { useEffect, useRef, useState } from "react";

// Экспонат: 3D-модель грузится, только когда секция подходит к экрану.
export default function ModelExhibit({ src, mobileSrc }: { src: string; mobileSrc?: string }) {
  const box = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const el = box.current;
    if (!el) return;
    let dispose: (() => void) | undefined;
    let cancelled = false;
    const io = new IntersectionObserver(
      async ([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        setLoading(true);
        const t0 = performance.now();
        const { mountExhibit } = await import("./exhibitScene");
        // телефонам — облегчённая модель: меньше треугольников, текстура 1024
        const small = mobileSrc && window.matchMedia("(max-width: 768px), (pointer: coarse)").matches;
        dispose = await mountExhibit(el, small ? mobileSrc : src, (info) => {
          // метрики — только для scripts/measure-model.mjs, в интерфейс не выводятся
          const ms = Math.round(performance.now() - t0);
          (window as unknown as { __exhibit?: object }).__exhibit = { ms, info };
        });
        if (cancelled) dispose();
        else setLoading(false);
      },
      { rootMargin: "300px" }
    );
    io.observe(el);
    return () => {
      cancelled = true;
      io.disconnect();
      dispose?.();
    };
  }, [src, mobileSrc]);

  return (
    <>
      <div ref={box} className="exhibit__stage" role="img" aria-label="Трёхмерная модель взрослого сизого голубя, вращается перетаскиванием" />
      {loading && <p className="label exhibit__loading">Загружаем экспонат…</p>}
    </>
  );
}
